import { useState } from "react";
import { Languages, Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "../../lib/api";

export const PAGE_LANGS = [["en", "English"], ["hi", "हिंदी"], ["mr", "मराठी"]];
const KEYS = ["title", "subtitle", "description", "refund_policy", "payment_description"];

// Language switch for the page's parent-facing text + one-tap AI draft for Hindi & Marathi.
export function PageLanguageBar({ lang, setLang, f, setTranslations }) {
  const [busy, setBusy] = useState(false);
  const filled = (code) => KEYS.some((k) => String(f.translations?.[code]?.[k] || "").replace(/<[^>]*>/g, "").trim());
  const translate = async () => {
    if (["hi", "mr"].some(filled) && !window.confirm("Replace the Hindi and Marathi text you already have with a fresh AI translation?")) return;
    setBusy(true);
    try {
      const { data } = await api.post("/pages/translate", { fields: Object.fromEntries(KEYS.map((k) => [k, f[k] || ""])), targets: ["hi", "mr"] });
      setTranslations({ ...(f.translations || {}), ...data.translations });
      toast.success("Hindi and Marathi filled in — check them, edit if needed, then Save");
      setLang("hi");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <div className="rounded-xl border border-indigo-100 bg-indigo-50/50 p-3 flex flex-wrap items-center gap-3" data-testid="page-language-bar">
      <Languages className="w-4 h-4 text-indigo-600" />
      <span className="text-xs font-semibold text-slate-600">Page text language</span>
      <div className="inline-flex bg-white rounded-full p-1 border border-slate-200">
        {PAGE_LANGS.map(([code, label]) => (
          <button key={code} type="button" onClick={() => setLang(code)} data-testid={`page-lang-${code}`}
            className={`px-3.5 py-1 rounded-full text-sm font-medium transition-colors ${lang === code ? "bg-indigo-600 text-white" : "text-slate-600 hover:bg-slate-100"}`}>
            {label}{code !== "en" && filled(code) && <span className={`ml-1 ${lang === code ? "text-white" : "text-emerald-600"}`}>✓</span>}
          </button>
        ))}
      </div>
      <button type="button" onClick={translate} disabled={busy || !(f.title || "").trim()} data-testid="page-translate-btn"
        className="ml-auto text-sm font-medium px-3 py-1.5 rounded-lg bg-white border border-indigo-200 text-indigo-700 hover:bg-indigo-50 disabled:opacity-50 flex items-center gap-1.5">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} Translate with AI
      </button>
      {lang !== "en" && <p className="w-full text-[11px] text-slate-500">Editing the {lang === "hi" ? "Hindi" : "Marathi"} version of the title, subtitle, description, payment description and refund policy. Leave a box empty to show English there. Form questions and buttons stay in English.</p>}
    </div>
  );
}
